import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "400px",
};

export default function MapPopup({ lat, lan, isOpen, onCloseMap }) {
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyCPsxZeXKcSYK1XXw0O0RbrZiI_Ekou5DY",
  });

  if (!isOpen || lat == null || lan == null) return null; // hide modal if closed

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <button style={styles.closeBtn} onClick={onCloseMap}>
          ✖
        </button>

        <h3 className="text-white mb-4">Location Map</h3>

        {!isLoaded ? (
          <p>Loading map…</p>
        ) : (
            <GoogleMap
            mapContainerStyle={containerStyle}
            center={{ lat: Number(lat), lng: Number(lan) }}
            zoom={15}
            >
            <Marker
                position={{ lat: Number(lat), lng: Number(lan) }}
                icon={{
                url: "https://maps.gstatic.com/mapfiles/ms2/micons/motorcycling.png",
                scaledSize: new window.google.maps.Size(40, 40),
                anchor: new window.google.maps.Point(25, 25),
                }}
            />
            </GoogleMap>
        )}
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modal: {
    background: "#202130",
    padding: "26px",
    borderRadius: "10px",
    width: "450px",
    position: "relative",
  },
  closeBtn: {
    position: "absolute",
    top: 16,
    right: 16,
    color: "#fff",
    border: "none",
    background: "transparent",
    fontSize: "16px",
    cursor: "pointer",
  },
};
